import { ChevronLeft } from '@tamagui/lucide-icons-2'
import { SizableText, Text, XStack, YStack } from 'tamagui'

interface Props {
    title: string
    titleChip?: React.ReactNode
    /** Muted line shown under the title (e.g. a result count). */
    subtitle?: React.ReactNode
    /** Back link shown above the title (e.g. "‹ Clients"). */
    back?: { label: string; onPress: () => void }
    /** @deprecated breadcrumbs are no longer shown (design removed them); kept for caller compatibility. */
    breadcrumbs?: Array<string>
    buttons?: React.ReactNode
    sx?: any
}

export default ({ title, titleChip, subtitle, back, buttons, sx }: Props) => {
    return (
        <YStack
            marginTop="$2"
            marginBottom="$5"
            gap="$2"
            {...sx}
        >
            {back ? (
                <XStack
                    alignItems="center"
                    gap="$1"
                    alignSelf="flex-start"
                    cursor="pointer"
                    onPress={back.onPress}
                    hoverStyle={{ opacity: 0.7 }}
                    marginBottom="$2"
                >
                    <ChevronLeft
                        size={16}
                        color="$colorMuted"
                    />
                    <SizableText
                        size="$2"
                        fontWeight="500"
                        color="$colorMuted"
                    >
                        {back.label}
                    </SizableText>
                </XStack>
            ) : null}
            <XStack
                gap="$3"
                flexDirection="row"
                alignItems="flex-start"
                flexWrap="wrap"
                justifyContent="space-between"
            >
                <YStack gap="$1">
                    <XStack
                        gap="$3"
                        alignItems="center"
                    >
                        <Text
                            fontSize="$8"
                            fontWeight="700"
                            letterSpacing={-0.5}
                        >
                            {title}
                        </Text>
                        {titleChip}
                    </XStack>
                    {subtitle ? (
                        <SizableText
                            size="$2"
                            color="$colorMuted"
                        >
                            {subtitle}
                        </SizableText>
                    ) : null}
                </YStack>
                {buttons}
            </XStack>
        </YStack>
    )
}
